import { useEffect, useState } from "react";
import { apiClient } from "@/context/AuthContext";
import { Copy, Link as LinkIcon, Loader2, Share2, Trash2, X } from "lucide-react";

export default function ShareModal({ report, onClose, onToast }) {
  const [ttl, setTtl] = useState(72);
  const [loading, setLoading] = useState(false);
  const [shares, setShares] = useState([]);

  const load = async () => {
    try {
      const { data } = await apiClient.get(`/reports/${report.id}/shares`);
      setShares(data || []);
    } catch { /* ignore */ }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [report.id]);

  const createShare = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.post(`/reports/${report.id}/share`, { ttl_hours: Number(ttl) || 72 });
      setShares((rs) => [data, ...rs]);
      onToast?.("Paylaşım bağlantısı üretildi");
    } catch (err) {
      onToast?.(err?.response?.data?.detail || "Bağlantı oluşturulamadı");
    } finally { setLoading(false); }
  };

  const revoke = async (sid) => {
    try {
      await apiClient.delete(`/reports/${report.id}/shares/${sid}`);
      setShares((rs) => rs.map((s) => s.id === sid ? { ...s, revoked: true } : s));
      onToast?.("Bağlantı iptal edildi");
    } catch { onToast?.("Bağlantı iptal edilemedi"); }
  };

  const linkFor = (token) => `${window.location.origin}/public/reports/${token}`;

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      onToast?.("Bağlantı kopyalandı");
    } catch { onToast?.("Kopyalanamadı — manuel seçin"); }
  };

  return (
    <div className="modal-backdrop" data-testid="share-modal">
      <div className="modal wide-modal">
        <div className="modal-head">
          <div><div className="eyebrow">RAPOR PAYLAŞIM BAĞLANTISI</div><h2>{report.code} · süreli erişim</h2></div>
          <button className="icon-button" onClick={onClose} data-testid="close-share-modal"><X size={17}/></button>
        </div>
        <div className="share-create">
          <label>Geçerlilik süresi (saat)
            <input type="number" min="1" max="720" value={ttl} onChange={(e) => setTtl(e.target.value)} data-testid="share-ttl-input"/>
          </label>
          <button className="primary-btn" onClick={createShare} disabled={loading} data-testid="create-share-button">
            {loading ? <Loader2 size={14} className="spin"/> : <Share2 size={14}/>} Yeni bağlantı üret
          </button>
        </div>
        <small className="legal-foot">Paylaşım bağlantısı salt-okunur PDF indirmesi sağlar; süresi dolunca otomatik devre dışı kalır.</small>
        <div className="share-list" data-testid="share-list">
          {!shares.length && <small className="evidence-empty">Henüz paylaşım bağlantısı yok.</small>}
          {shares.map((s) => (
            <div key={s.id} className={`share-row ${s.revoked ? "revoked" : ""}`} data-testid={`share-${s.id}`}>
              <div className="share-main">
                <div className="share-link">
                  <LinkIcon size={12}/>
                  <code>{linkFor(s.token)}</code>
                </div>
                <small>
                  TTL {s.ttl_hours}sa · Oluşturan {s.created_by}
                  · Son geçerlilik {(s.expires_at||"").slice(0,19).replace("T"," ")}
                  · Erişim {s.access_count}
                  {s.revoked ? " · İPTAL EDİLDİ" : ""}
                </small>
              </div>
              <button className="icon-button" onClick={() => copy(linkFor(s.token))} data-testid={`share-copy-${s.id}`} title="Kopyala"><Copy size={13}/></button>
              {!s.revoked && <button className="icon-button" onClick={() => revoke(s.id)} data-testid={`share-revoke-${s.id}`} title="İptal"><Trash2 size={13}/></button>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
